import Customer from '../views/customer/Index.vue';
import { checkauth } from '../Helper';

// inserimento e modifica sono pagine: tornando indietro la lista riparte dal suo URL
const CustomerCreate = () => import('../views/customer/Create.vue');
const CustomerEdit = () => import('../views/customer/Edit.vue');

function auth(to, from, next) {
	checkauth().then(response => {
		if (response) {
			next();
		} else {
			next('/login');
		}
	});
}

export default [
	{
		path: '/customers',
		name: 'customers',
		component: Customer,
		beforeEnter: auth,
	},
	{
		path: '/customers/new',
		name: 'customer-new',
		component: CustomerCreate,
		beforeEnter: auth,
	},
	// :id e' l'_id del cliente (24 caratteri esadecimali): "new" non puo' mai finire qui
	{
		path: '/customers/:id([0-9a-fA-F]{24})',
		name: 'customer-edit',
		component: CustomerEdit,
		beforeEnter: auth,
	},
];
